import { render, staticRenderFns } from "./WorkHoursPanel.vue?vue&type=template&id=04172844"
import script from "./WorkHoursPanel.vue?vue&type=script&lang=ts"
export * from "./WorkHoursPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports